import React, { useEffect, useState } from 'react'
import NewsItem from './NewsItem'
import Spinner from './Spinner';
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroll-component';

const News = (props) => {

    const fakearticles = [
        {
            "source": {
                "id": null,
                "name": "CNBC"
            },
            "author": "Brian Evans",
            "title": "Stock futures fall as investors eye Israel-Iran conflict: Live updates - CNBC",
            "description": "The major averages started the new week with solid gains on Monday.",
            "url": "https://www.cnbc.com/2025/06/16/stock-market-today-live-updates.html",
            "urlToImage": "https://image.cnbcfm.com/api/v1/image/108118311-1742395631787-gettyimages-2205876233-markets602920_cmbvxcpl.jpeg?v=1742395687&w=1920&h=1080",
            "publishedAt": "2025-06-17T08:04:00Z",
            "content": "Stock futures were lower on Tuesday morning as investors continued to monitor the conflict between Israel and Iran.\r\nFutures tied to the Dow Jones Industrial Average declined 301 points, or 0.7%. S&a… [+2274 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "BBC News"
            },
            "author": null,
            "title": "Newspaper headlines: 'A generation let down' and 'Israel claims control' - BBC",
            "description": "Tuesday's front pages are dominated by the reaction to Baroness Louise Casey's report on grooming gangs.",
            "url": "https://www.bbc.com/news/articles/cx24gpn4x62o",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/c012/live/ec852f80-4b00-11f0-a466-d54f65b60deb.jpg",
            "publishedAt": "2025-06-17T04:26:49Z",
            "content": "The Casey report on grooming gangs dominates the front pages.\r\n\"Conspiracy of silence over race doomed thousands of girls to abuse\" is the Daily Mail's headline. Its editorial calls what happened \"on… [+1840 chars]"
        },
        {
            "source": {
                "id": "associated-press",
                "name": "Associated Press"
            },
            "author": "AP News",
            "title": "Trump is at a moment of choosing as Israel looks for more US help crushing Iran's nuclear program - AP News",
            "description": null,
            "url": "https://apnews.com/article/trump-iran-nuclear-israel-g7-132d92f3b5f4014cced1c5029d839ae9",
            "urlToImage": null,
            "publishedAt": "2025-06-17T04:22:00Z",
            "content": null
        },
        {
            "source": {
                "id": null,
                "name": "FXStreet"
            },
            "author": "FXStreet Team",
            "title": "Bank of Japan leaves interest rate unadjusted at 0.5% as expected - FXStreet",
            "description": "Bank of Japan (BoJ) Governor Kazuo Ueda is holding a press conference to explain the reasons behind maintaining the key interest rate at 0.5% on Tuesday.",
            "url": "https://www.fxstreet.com/news/bank-of-japan-set-to-hold-rates-steady-as-officials-mull-halving-the-pace-of-tapering-jgb-purchases-202506162300",
            "urlToImage": "https://editorial.fxsstatic.com/images/i/Japanese-Bank_4_Large.png",
            "publishedAt": "2025-06-17T04:00:01Z",
            "content": "Bank of Japan (BoJ) Governor Kazuo Ueda is holding a press conference to explain the reasons behind maintaining the key interest rate at 0.5% on Tuesday.  \r\nThe Japanese Yen wavers in a familiar rang… [+10409 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Livemint"
            },
            "author": "Livemint",
            "title": "Donald Trump's family launches 'Made in America' T1 smartphone. Here's what it offers - Mint",
            "description": "Donald Trump’s family launches Trump Mobile, a mobile phone service utilizing existing US carrier networks. The venture raises conflict of interest concerns as Trump retains business interests while in office.",
            "url": "https://www.livemint.com/news/world/donald-trumps-family-launches-made-in-america-t1-smartphone-heres-what-it-offers-11750128008442.html",
            "urlToImage": "https://www.livemint.com/lm-img/img/2025/06/17/1600x900/Canada-G7-Summit-22_1750129342584_1750129391160.jpg",
            "publishedAt": "2025-06-17T03:52:05Z",
            "content": "US President Donald Trumps family is entering the mobile phone market with a new Trump-branded service called Trump Mobile, which will operate using existing wireless networks and American-made hardw… [+4208 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Space.com"
            },
            "author": "Robert Z. Pearlman",
            "title": "SpaceX launch from California sends 26 Starlink satellites into low Earth orbit - Space",
            "description": "Liftoff occurred at 11:36 p.m. EDT on Monday (June 16).",
            "url": "https://www.space.com/space-exploration/launches-spacecraft/spacex-starlink-15-9-b1093-vsfs-ocisly",
            "urlToImage": "https://cdn.mos.cms.futurecdn.net/rBANprW37nq7d2uwhYMv6h.jpg",
            "publishedAt": "2025-06-17T03:51:10Z",
            "content": "SpaceX launched 26 Starlink satellites from California on Monday evening (June 16).\r\nA relatively new Falcon 9 rocket, making only its third flight, lifted off at 8:36 p.m. PDT local (11:36 p.m. EDT … [+1842 chars]"
        },
        {
            "source": {
                "id": "bleacher-report",
                "name": "Bleacher Report"
            },
            "author": "Taylyn Hadley",
            "title": "SGA, Jalen Williams Help Thunder Hold Off Pacers in Game 5 as NBA Fans Eye OKC Title - Bleacher Report",
            "description": "It was a full-on Jalen Williams takeover in Game 5 of the NBA Finals, as he poured in a playoff career-high 40 points in what amounted to the greatest game of his career so far.",
            "url": "https://bleacherreport.com/articles/25208916-sga-jalen-williams-help-thunder-hold-pacers-game-5-nba-fans-eye-okc-title",
            "urlToImage": "https://gsp-image-cdn.wmsports.io/cms/prod/bleacher-report/getty_images/2219304817_large_image.jpg?w=3800&h=2000",
            "publishedAt": "2025-06-17T03:27:52Z",
            "content": "It was a full-on Jalen Williams takeover in Game 5 of the NBA Finals, as he poured in a playoff career-high 40 points in what amounted to the greatest game of his career so far. \r\nWilliams and Shai G… [+2458 chars]"
        },
        {
            "source": {
                "id": "abc-news",
                "name": "ABC News"
            },
            "author": "ABC News",
            "title": "Children of slain Minnesota lawmaker Melissa Hortman: 'We are devastated' - ABC News",
            "description": null,
            "url": "https://abcnews.go.com/US/children-slain-minnesota-lawmaker-melissa-hortman-devastated/story?id\\\\u003d122915277",
            "urlToImage": null,
            "publishedAt": "2025-06-17T03:00:00Z",
            "content": null
        },
        {
            "source": {
                "id": "the-washington-post",
                "name": "The Washington Post"
            },
            "author": "Kareem Fahim, Susannah George",
            "title": "Arab gulf states work to contain fallout from Israel’s attack on Iran - The Washington Post",
            "description": "Oman and Qatar were leading efforts to begin ceasefire talks, while mediators said Iran was open to resuming nuclear negotiations if Israel’s attacks stop.",
            "url": "https://www.washingtonpost.com/world/2025/06/16/israel-iran-conflict-gulf-states/",
            "urlToImage": "https://www.washingtonpost.com/wp-apps/imrs.php?src=https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/WSM4NWZKDEI2PVAFN4DNB5477I.jpg&w=1440",
            "publishedAt": "2025-06-17T02:15:41Z",
            "content": "Iranian officials have told mediators they are open to resuming nuclear talks with the United States, but they first want Israel to stop its attacks, two officials briefed on the matter said Monday, … [+8809 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "NBCSports.com"
            },
            "author": "Mike Florio",
            "title": "Victims of West Virginia flooding need our help - NBC Sports",
            "description": "This is something I don't do very often.",
            "url": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/victims-of-west-virginia-flooding-need-our-help",
            "urlToImage": "https://nbcsports.brightspotcdn.com/dims4/default/b97cf7d/2147483647/strip/true/crop/1140x641+0+78/resize/1440x810!/quality/90/?url=https%3A%2F%2Fnbc-sports-production-nbc-sports.s3.us-east-1.amazonaws.com%2Fbrightspot%2Ff5%2F49%2Fefd5d61d4c44bae18c05d037a21f%2Fwheelingflood061625-01-2-1750113866.jpg",
            "publishedAt": "2025-06-17T02:03:52Z",
            "content": "This is something I dont do very often. Fortunately, there are few natural disasters in my home state and in my hometown that require me to do it.\r\nDespite the 16-year relationship with NBC, PFT is a… [+1991 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "BBC News"
            },
            "author": null,
            "title": "California doctor to plead guilty to supplying Matthew Perry with ketamine - BBC",
            "description": "The actor - best known for playing Chandler Bing on Friends – was found dead in his hot tub in October 2023.",
            "url": "https://www.bbc.com/news/articles/c784l795lzdo",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/82ac/live/3599dc20-4b2e-11f0-a0d2-273f81f8612c.jpg",
            "publishedAt": "2025-06-17T01:42:26Z",
            "content": "A California doctor accused of giving Friends star Matthew Perry access to ketamine in the weeks before the actor's overdose death has agreed to plead guilty, according to federal prosecutors. \r\nDr S… [+1654 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Page Six"
            },
            "author": "Audrey Rock",
            "title": "Brad Pitt and Ines de Ramon have PDA-packed date night at ‘F1’ premiere in NYC - Page Six",
            "description": "Pitt was seen leading de Ramon by the hand and wrapping his arm around her waist at the event.",
            "url": "https://pagesix.com/2025/06/16/celebrity-news/brad-pitt-and-ines-de-ramon-have-date-night-at-f1-premiere/",
            "urlToImage": "https://pagesix.com/wp-content/uploads/sites/3/2025/06/106619695.jpg?quality=75&strip=all&w=1024",
            "publishedAt": "2025-06-17T01:40:00Z",
            "content": "Brad Pitt and Ines de Ramon were glowing on their PDA-packed date night at the F1 premiere in New York City.\r\nThe Oscar-winning actor led his girlfriend by the hand while stepping onto the red carpet… [+2709 chars]"
        },
        {
            "source": {
                "id": "cnn",
                "name": "CNN"
            },
            "author": "Tami Luhby, Ella Nilsen, Manu Raju, Sarah Ferris",
            "title": "Senate Republicans unveil plan for cuts to Medicaid and taxes in Trump agenda bill - CNN",
            "description": "The Senate Finance Committee on Monday released its version of the GOP’s package that calls for enacting sweeping cuts to Medicaid and preventing a multi-trillion dollar tax hike on Americans.",
            "url": "https://www.cnn.com/2025/06/16/politics/medicaid-cuts-senate-tax-bill",
            "urlToImage": "https://media.cnn.com/api/v1/images/stellar/prod/c-gettyimages-2220451332.jpg?c=16x9&q=w_800,c_fill",
            "publishedAt": "2025-06-17T01:30:00Z",
            "content": "The GOP-ledSenate Finance Committee on Monday released itsproposal for President Donald Trumps agenda billthat calls for enacting sweeping cuts to Medicaid and preventing a multi-trillion dollar tax … [+6774 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "MassLive.com"
            },
            "author": "Sean McAdam | sean.mcadam@masslive.com",
            "title": "Red Sox worried that Rafael Devers’ refusal to change positions would send wrong message on team culture - MassLive",
            "description": "Rafael Devers balked at becoming the Red Sox' DH, and later refused to try out first base. The team worried that would be a dangerous precedent for a roster filled with rookies.",
            "url": "https://www.masslive.com/redsox/2025/06/red-sox-worried-that-rafael-devers-refusal-to-change-positions-would-send-wrong-message-on-team-culture.html",
            "urlToImage": "https://www.masslive.com/resizer/v2/G2Z5TNXC2NCWHEKY56EBVRPHPM.jpg?auth=09ff566a781ae3a30a42b9f15c36490686f72fd0de9702e41358f10f8a5b0c2b&width=1280&quality=90",
            "publishedAt": "2025-06-17T01:27:00Z",
            "content": null
        },
        {
            "source": {
                "id": "abc-news",
                "name": "ABC News"
            },
            "author": "ABC News",
            "title": "Diddy trial day 28 recap: Judge dismisses a juror over a 'lack of candor' - ABC News",
            "description": null,
            "url": "https://abcnews.go.com/US/diddy-trial-day-28-recap-judge-dismisses-juror/story?id\\\\u003d122912700",
            "urlToImage": null,
            "publishedAt": "2025-06-17T00:57:09Z",
            "content": null
        },
        {
            "source": {
                "id": "abc-news",
                "name": "ABC News"
            },
            "author": null,
            "title": "Police question 2 armed 'peacekeepers' in Salt Lake City's 'No Kings' protest death - ABC News",
            "description": null,
            "url": "https://abcnews.go.com/US/police-question-2-armed-peacekeepers-salt-lake-citys/story?id\\\\u003d122910671",
            "urlToImage": null,
            "publishedAt": "2025-06-16T23:31:11Z",
            "content": "Description: Group Number: Group Name: Ip Address: Username: Computer Name:"
        },
        {
            "source": {
                "id": "politico",
                "name": "Politico"
            },
            "author": "Gregory Svirnovskiy",
            "title": "American Bar Association sues Trump administration over executive orders targeting law firms - Politico",
            "description": "It claims the executive orders pursued by the White House have cast a chill across the legal industry.",
            "url": "https://www.politico.com/news/2025/06/16/american-bar-association-sues-trump-00409204",
            "urlToImage": "https://static.politico.com/fd/18/41cd5bd04169a03de0231a8c90f1/https-delivery-gettyimages.com/downloads/2220445402",
            "publishedAt": "2025-06-16T22:02:57Z",
            "content": "Throughout his first several months in office, Trump has hammered major law firms, including Paul, Weiss, Rifkind, Wharton &amp; Garrison, with executive orders and memos seeking to freeze their fede… [+2325 chars]"
        },
        {
            "source": {
                "id": "the-verge",
                "name": "The Verge"
            },
            "author": "Andrew Liszewski",
            "title": "Charge your Apple Watch on this tiny iMac G3 replica - The Verge",
            "description": "Spigen’s Apple Watch Classic C1 Charger Stand is fun and functional, positioning your smartwatch at an angle while it charges.",
            "url": "https://www.theverge.com/news/687749/spigen-apple-watch-classic-c1-charger-stand",
            "urlToImage": "https://platform.theverge.com/wp-content/uploads/sites/2/2025/06/spigen1.jpg?quality=90&strip=all&crop=0%2C10.698986876997%2C100%2C78.602026246005&w=1200",
            "publishedAt": "2025-06-16T19:42:11Z",
            "content": "Its even available in the iMac G3s original bondi blue color.\r\nPrevious additions to Spigens Classic C1 series of Apple accessories include iPhone and AirPods cases inspired by the iMac G3s bright co… [+1006 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "GameSpot"
            },
            "author": "Jordan Ramée",
            "title": "Sonic Racing: CrossWorlds Drops The Best Aspects Of Its Predecessors - GameSpot",
            "description": "Let's just go back to making sequels to Sonic Riders.",
            "url": "https://www.gamespot.com/articles/sonic-racing-crossworlds-drops-the-best-aspects-of-its-predecessors/1100-6532469/",
            "urlToImage": "https://www.gamespot.com/a/uploads/screen_kubrick/1587/15875866/4514619-sonicracingcrossworlds_hero.jpg",
            "publishedAt": "2025-06-16T19:40:11Z",
            "content": "Sonic Racing: CrossWorlds is fun, but it feels a little too much like other kart racers. The follow-up to Team Sonic Racing aims to combine its predecessor's formula with the more competitive make-up… [+4492 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Kotaku"
            },
            "author": "Zack Zwiezen",
            "title": "Nintendo's Mysterious Absence From Amazon Ends With No Explanation - Kotaku",
            "description": "New Nintendo games like Donkey Kong Bananza on Switch 2 are available on the site",
            "url": "https://kotaku.com/amazon-switch-2-nintendo-mario-donkey-kong-pre-orders-1851784603",
            "urlToImage": "https://i.kinja-img.com/image/upload/c_fill,h_675,pg_1,q_80,w_1200/452eec11757452c6a00902904aee1299.jpg",
            "publishedAt": "2025-06-16T19:30:00Z",
            "content": "For over a year now, online retailer Amazon hasnt directly sold new first-party Nintendo games or accessories. It also skipped out on the Switch 2 launch. But over the weekend, the situation changed,… [+1695 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Push Square"
            },
            "author": "Robert Ramsey",
            "title": "Clair Obscur: Expedition 33 Teases Big Improvements for Future Updates - Push Square",
            "description": "For the sake of tomorrow",
            "url": "https://www.pushsquare.com/news/2025/06/clair-obscur-expedition-33-teases-big-improvements-for-future-updates",
            "urlToImage": "https://images.pushsquare.com/9952817530fd1/large.jpg",
            "publishedAt": "2025-06-16T18:38:23Z",
            "content": "@rjejr I think that it's stated or at the very least implied that the handholds were installed by previous expeditions. That's why they're not just rock handholds and rather why they look like device… [+1126 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "ZDNet"
            },
            "author": "Artie Beaty",
            "title": "Meta Oakley smart glasses could arrive this week. Here's everything we know - ZDNET",
            "description": "The newest Meta smart glasses will target athletes, according to reports. We'll learn more this Friday.",
            "url": "https://www.zdnet.com/article/forget-ray-bans-the-new-meta-oakley-smart-glasses-may-interest-some-users-more/",
            "urlToImage": "https://www.zdnet.com/a/img/resize/1718be37f6c2b269805c7bcda8482e93f4ff3ae0/2023/09/26/2f85c6f6-2c66-4cd0-b378-95d9a1efc574/ray-ban-smart-glasses-designs.jpg?auto=webp&fit=crop&height=675&width=1200",
            "publishedAt": "2025-06-16T18:29:00Z",
            "content": "The Ray-Ban Meta smart glasses came in various styles and colors. Will the Oakley partnership take a similar approach?\r\nKerry Wan/ZDNET\r\nSeveral months ago, reports emerged that Meta was looking to e… [+2162 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Forbes"
            },
            "author": "Ty Roush",
            "title": "Northern Lights Alert: 8 States May See Aurora Borealis Monday Night - Forbes",
            "description": "Forecasters said periods of “minor” geomagnetic storms are expected.",
            "url": "https://www.forbes.com/sites/tylerroush/2025/06/16/northern-lights-forecast-geomagnetic-storms-could-bring-aurora-borealis-to-these-8-states-tonight/",
            "urlToImage": "https://imageio.forbes.com/specials-images/imageserve/67374d824b0b913222945c25/0x0.jpg?format=jpg&crop=3500,1968,x0,y180,safe&height=900&width=1600&fit=bounds",
            "publishedAt": "2025-06-16T18:09:11Z",
            "content": "Some geomagnetic storm conditions are expected Monday, possibly making the northern lights visible in several states in the northern U.S., according to the National Oceanic and Atmospheric Administra… [+2217 chars]"
        },
        {
            "source": {
                "id": "ign",
                "name": "IGN"
            },
            "author": "Christian Wait",
            "title": "The Biggest Pokémon Card Crashers And Climbers This Week - June 16 - IGN",
            "description": "As of June 16, we're seeing even more massive changes for cards from Pokémon TCG Scarlet & Violet: Destined Rivals. Here's the biggest price drops and rising picks for the week.",
            "url": "https://www.ign.com/articles/the-biggest-pokmon-card-crashers-and-climbers-this-week-june-16",
            "urlToImage": "https://assets-prd.ignimgs.com/2025/06/16/pokemon-tcg-market-watch-climbers-and-crashers-ign-june-16-1750082731970.png?width=1280",
            "publishedAt": "2025-06-16T18:03:24Z",
            "content": "In the last Crashers and Climbers, I was focused on Destined Rivals, thanks to it just launching. I was going to look into older sets this week, but the volatility of this set right now forced me to … [+5831 chars]"
        },
        {
            "source": {
                "id": "techcrunch",
                "name": "TechCrunch"
            },
            "author": "Amanda Silberling",
            "title": "Threads is testing spoiler text, Zuckerberg says - TechCrunch",
            "description": "Threads, Meta's microblogging platform, is testing spoiler text. This is a nice quality-of-life upgrade on the user side, but it also helps Meta by encouraging more conversations about pop culture without people worrying about spoiling others.",
            "url": "https://techcrunch.com/2025/06/16/threads-is-testing-spoiler-text-zuckerberg-says/",
            "urlToImage": "https://techcrunch.com/wp-content/uploads/2024/12/instagram-threads-GettyImages-2159215889.jpg?resize=1200,800",
            "publishedAt": "2025-06-16T17:54:51Z",
            "content": "Threads, Meta’s microblogging platform, is testing spoiler text, according to a post from Meta CEO Mark Zuckerberg.\r\nSpoiler text refers to words (or images) that are grayed out in a post and only be… [+1214 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Realtor.com News"
            },
            "author": "Realtor.com",
            "title": "Inside J.J. Spaun's Arizona Home as He Claims Surprising U.S. Open Win - Realtor.com",
            "description": null,
            "url": "https://www.realtor.com/news/celebrity-real-estate/jj-spaun-golf-us-open-win-home-arizona/",
            "urlToImage": null,
            "publishedAt": "2025-06-16T21:13:05Z",
            "content": null
        },
        {
            "source": {
                "id": "nhl-news",
                "name": "NHL News"
            },
            "author": null,
            "title": "United States roster at 2026 Olympics will differ from 4 Nations Face-Off, GM says - NHL.com",
            "description": "Guerin won't 'run it back with the same team' after OT loss to Canada in championship game",
            "url": "https://www.nhl.com/news/bill-guerin-will-start-from-scratch-to-build-usa-roster-for-2026-olympics",
            "urlToImage": "https://media.d3.nhle.com/image/private/t_ratio16_9-size50/v1740773637/prd/btuxyvwsdj2wlffwioej.png",
            "publishedAt": "2025-06-16T19:29:55Z",
            "content": "The United States will likely have a different look at the Olympic Winter Games Milano Cortina 2026 after it lost to Canada in overtime of the championship game at the 4 Nations Face-Off in February.… [+2729 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "MLB.com"
            },
            "author": "Joe Trezza",
            "title": "All you need to know about 2025 MLB Draft Combine - MLB.com",
            "description": "MLB's fifth annual Draft Combine will give teams the opportunity to gather more information on and off the field about several of the top talents in this year's crop. A total of 322 prospects have accepted invitations to the event, scheduled for June 17-21 at…",
            "url": "https://www.mlb.com/news/2025-mlb-draft-combine-preview",
            "urlToImage": "https://img.mlbstatic.com/mlb-images/image/upload/t_2x1/t_w1536/mlb/c40q7pp0pxuhi4tmpxyg.jpg",
            "publishedAt": "2025-06-16T19:21:11Z",
            "content": "MLB's fifth annual Draft Combine will give teams the opportunity to gather more information on and off the field about several of the top talents in this year's crop. A total of 322 prospects have ac… [+5622 chars]"
        },
        {
            "source": {
                "id": "fox-sports",
                "name": "Fox Sports"
            },
            "author": "Bob Pockrass",
            "title": "NASCAR hopeful for deserved return to Mexico City in 2026; will INDYCAR join? - FOX Sports",
            "description": "The Cup Series went to Mexico for the first time, leaving drivers and fans enthusiastic. Now, will both NASCAR and INDYCAR head there in 2026?",
            "url": "https://www.foxsports.com/stories/nascar/nascar-indycar-mexico-city-2026",
            "urlToImage": "https://a57.foxsports.com/statics.foxsports.com/www.foxsports.com/content/uploads/2025/06/1408/814/4a524c2a-mexico1.jpg?ve=1&tl=1",
            "publishedAt": "2025-06-16T17:25:00Z",
            "content": "MEXICO CITY The Autodromo Hermanos Rodriguez circuit in Mexico City has played host to Formula 1 races for several years. This year, the NASCAR Cup Series made its debut at the facility.\r\nINDYCAR cou… [+7634 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "MLB Trade Rumors"
            },
            "author": "Darragh McDonald",
            "title": "Yankees To Reinstate Giancarlo Stanton - MLB Trade Rumors",
            "description": "Giancarlo is back. Click over to MLB Trade Rumors to read more about it.",
            "url": "https://www.mlbtraderumors.com/2025/06/yankees-to-reinstate-giancarlo-stanton.html",
            "urlToImage": "https://cdn.mlbtraderumors.com/files/2025/03/USATSI_24629886-1024x654.jpg",
            "publishedAt": "2025-06-16T17:04:57Z",
            "content": "Designated hitter Giancarlo Stanton will be back in the lineup tonight, reports Andy Martino of SNY. Stanton is on the 60-day injured list, meaning he will need to retake a spot on the 40-man roster … [+3228 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Pitcherlist.com"
            },
            "author": "Nick Pollack",
            "title": "Fantasy Baseball SP Roundup 6/15: The Long Awaited Brayan K.O. - Pitcher List",
            "description": "Nick Pollack reviews every starting pitcher performance from Sunday.",
            "url": "http://pitcherlist.com/sp-roundup-6-15-25/",
            "urlToImage": "https://pitcherlist.com/wp-content/uploads/2025/06/2025.06.15-SP-Roundup-Brayan-Bello.jpg",
            "publishedAt": "2025-06-16T16:25:53Z",
            "content": "Welcome to the SP Roundup, my daily fantasy baseball article reviewing every starting pitcher’s performance from every Sunday game. I apologize for the jokes written in my delirium in advance. Have q… [+16965 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Boston.com"
            },
            "author": "Khari A. Thompson",
            "title": "4 ways the Desmond Bane trade could affect the Celtics - Boston.com",
            "description": "A playoff opponent addressed it's biggest weakness. Multiple pick changed hands. Here's how the Desmond Bane trade affects the Celtics.",
            "url": "https://www.boston.com/sports/boston-celtics/2025/06/16/desmond-bane-trade-magic-grizzlies-celtics-analysis/",
            "urlToImage": "https://bdc2020.o0bc.com/wp-content/uploads/2025/06/TMTGAYDS4TKYJZBMRVTUOS7SIM-68503f267ae1c-768x432.jpg",
            "publishedAt": "2025-06-16T16:13:00Z",
            "content": "CelticsOrlando addressed a huge weakness and gave up a bunch of picks. How does that affect the Celtics?\r\nDesmond Bane. AP Photo/Jacob Kupferman\r\nDesmond Bane, the 6-foot-5 inch, 215-pound sharpshoot… [+4738 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "WRAL.com"
            },
            "author": "WRAL Staff",
            "title": "Rabid fox bites person in Raleigh - WRAL.com",
            "description": "A fox in Raleigh has tested positive for rabies after biting a person over the weekend on Marathon Lane, resulting in minor injuries.",
            "url": "https://www.wral.com/news/local/rabid-fox-bites-person-raleigh-june-2025/",
            "urlToImage": "https://images.wral.com/3a4f7c78-5f19-4faa-9167-8544ae0dc089?w=1200&h=630",
            "publishedAt": "2025-06-16T20:08:52Z",
            "content": "A fox has\r\ntested positive for rabies after biting someone over the weekend, the Raleigh\r\nPolice Department said.\r\nRaleigh police\r\nresponded Saturday to Marathon Lane near Alenja Lane about someone g… [+1215 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Neurosciencenews.com"
            },
            "author": "Neuroscience News",
            "title": "How the Brain Actively Removes Unwanted Memories - Neuroscience News",
            "description": "New research reveals that people can consciously remove specific information from their memories by dampening the brain circuits that initially stored it.",
            "url": "https://neurosciencenews.com/brain-memory-removal-29275/",
            "urlToImage": "https://neurosciencenews.com/files/2025/06/memory-forgetting-neuroscience.jpg",
            "publishedAt": "2025-06-16T20:04:46Z",
            "content": "Summary: New research reveals that people can consciously remove specific information from their memories by dampening the brain circuits that initially stored it. In a recent study, participants wer… [+4107 chars]"
        },
        {
            "source": {
                "id": "the-washington-post",
                "name": "The Washington Post"
            },
            "author": "Brian Vines",
            "title": "Too often, Black patients get late diagnoses of deadly skin cancer - The Washington Post",
            "description": "For Black people, surviving skin cancer begins with knowing what to look for — and where to look.",
            "url": "https://www.washingtonpost.com/wellness/2025/06/16/skin-cancer-black-melanoma/",
            "urlToImage": "https://www.washingtonpost.com/wp-apps/imrs.php?src=https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/YG3UN2JL72FCHCRVKERG4QIZNE.jpg&w=1440",
            "publishedAt": "2025-06-16T19:32:13Z",
            "content": "Consumer Reports has no financial relationship with any advertisers on this site.\r\nThe abundance in Black skin of melanin, the pigment that gives skin its color, offers extra protection from damaging… [+8692 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "PsyPost"
            },
            "author": "Scott Chiesa",
            "title": "Dementia risk begins in childhood, not old age, scientists warn - PsyPost",
            "description": "New research suggests that dementia prevention should begin much earlier than previously thought—possibly as early as childhood. Experts argue that addressing risk factors like obesity, smoking, and inactivity early in life could reduce the chances of develop…",
            "url": "https://www.psypost.org/dementia-risk-begins-in-childhood-not-old-age-scientists-warn/",
            "urlToImage": "https://www.psypost.org/wp-content/uploads/2024/12/teen-boy-eating-snack-food.jpg",
            "publishedAt": "2025-06-16T18:02:35Z",
            "content": "More than 60 million people are estimated to be living with dementia, resulting in over 1.5 million deaths a year and an annual cost to the global healthcare economy of around US $1.3 trillion (almos… [+5129 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Parkinson's News Today"
            },
            "author": "Margarida Maia, PhD",
            "title": "Aged neurons don’t respond normally to stress: Study - Parkinson's News Today",
            "description": "Aging interferes with the way neurons respond to stress, making them more likely to contribute to disease such as Parkinson’s, a study found.",
            "url": "https://parkinsonsnewstoday.com/?p=111871&preview=true&preview_id=111871",
            "urlToImage": "https://parkinsonsnewstoday.com/wp-content/uploads/2025/06/Neurons-Electric.png",
            "publishedAt": "2025-06-16T17:58:49Z",
            "content": "Aging interferes with the way neurons, or nerve cells, respond to stress, making them more susceptible to damage and more likely to contribute to neurodegenerative diseases such as Parkinsons, accord… [+4025 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "ABC15 Arizona"
            },
            "author": "abc15.com staff",
            "title": "Person infectious with measles traveled through Sky Harbor, health officials say - ABC15 Arizona",
            "description": "Maricopa County Department of Public Health says a person infectious with measles traveled through Phoenix Sky Harbor last week.",
            "url": "https://www.abc15.com/news/local-news/person-infectious-with-measles-traveled-through-sky-harbor-health-officials-say",
            "urlToImage": "https://ewscripps.brightspotcdn.com/dims4/default/7761490/2147483647/strip/true/crop/2023x1062+250+0/resize/1200x630!/quality/90/?url=http%3A%2F%2Fewscripps-brightspot.s3.amazonaws.com%2Fe2%2F3a%2Fae57e7394495a354182a45a695fa%2Fscreen-shot-2022-01-03-at-7.52.56%20AM.png",
            "publishedAt": "2025-06-16T17:46:01Z",
            "content": "PHOENIX Maricopa County Department of Public Health says a person infectious with measles traveled through Phoenix Sky Harbor last week.\r\nOfficials are working with federal, state, and airport offici… [+1349 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Livemint"
            },
            "author": "Ravi Hari",
            "title": "Aspergillus fumigatus, lethal fungus spreading across US raises alarm — Florida, Texas, California & more states at risk - Mint",
            "description": "A deadly airborne fungus, Aspergillus fumigatus, is spreading rapidly in the US, threatening people with weakened immune systems. It causes aspergillosis, a fatal lung infection, with rising heat, drug resistance, and poor tracking worsening the crisis.",
            "url": "https://www.livemint.com/news/us-news/aspergillus-fumigatus-lethal-fungus-spreading-across-us-raises-alarm-florida-texas-california-more-statat-ris-11750092959856.html",
            "urlToImage": "https://www.livemint.com/lm-img/img/2025/06/16/1600x900/gd79194b06a1c7f68b999e2a8a347fa2a1fbe9ee75ec28c707_1750095314562_1750095314742.jpg",
            "publishedAt": "2025-06-16T17:35:37Z",
            "content": "A deadly fungus that can rot human tissue from within is rapidly spreading across the United States, with experts sounding alarm over rising temperatures, widespread drug resistance, and the lack of … [+3771 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Eatingwell.com"
            },
            "author": "https://www.facebook.com/EatingWell/",
            "title": "11 Sneaky Reasons You're So Gassy, According to Experts - EatingWell",
            "description": "Health experts reveal the subtle reasons you might be feeling more flatulent than usual, and how to help reduce your symptoms.",
            "url": "https://www.eatingwell.com/sneaky-reasons-youre-so-gassy-11755428",
            "urlToImage": "https://www.eatingwell.com/thmb/jSt_ocphEps4VqKiMuYOy5RcjDk=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/11-Sneaky-Reasons-Youre-So-Gassy-08e4e126770e4a5ba83ae651101ecf51.jpg",
            "publishedAt": "2025-06-16T17:30:00Z",
            "content": "Being gassy stinks (sometimes literally!). Sure, it's a totally normal part of being human (word is most people let one rip between 10 and 12 times a day).But if you're feeling the effects of excessi… [+9243 chars]"
        }
    ]

    const [articles, setarticles] = useState([]);
    const [loading, setloading] = useState(true);
    const [page, setpage] = useState(1);
    const [totalResults, settotalResults] = useState(0);

    const finalizefirstchar = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    const updatenews = async () => {
        try {
            props.setProgress(10)
            const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apikey}&page=${page}&pagesize=${props.pagesize}`;
            setloading(true)
            props.setProgress(40)
            let data = await fetch(url);
            let parseddata = await data.json();

            if (parseddata.status === "ok") {

                props.setProgress(70)
                setarticles(parseddata.articles);
                settotalResults(parseddata.totalResults);
                setloading(false);

                props.setProgress(100)
            }
            else throw new Error();

        }
        catch {
            setarticles(fakearticles);
            setloading(false);
            props.setProgress(100)
        }


    }
    useEffect(() => {
        document.title = `NewsHeadz - ${finalizefirstchar(props.category)}`
        updatenews();// eslint-disable-next-line 
    }, [])


    const fetchMoreData = async () => {

        try {

            const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apikey}&page=${page + 1}&pagesize=${props.pagesize}`;
            setpage(page + 1)

            setloading(true)
            let data = await fetch(url);
            let parseddata = await data.json();
            if (parseddata.status === "ok") {

                setarticles(articles.concat(parseddata.articles));
                settotalResults(parseddata.totalResults);
                setloading(false);
            }
            else throw new Error();

        }
        catch {

            setarticles(fakearticles);
            setloading(false);
            props.setProgress(100)
        }


    };



    return (
        <div className='container my-3'>
            <h1 className='text-center' style={{ marginTop: '100px', marginBottom: '20px' }}>NewsHeadz - Top Headlines from {finalizefirstchar(props.category)}</h1>
            {loading && <Spinner />}
            <InfiniteScroll
                dataLength={articles.length}
                next={fetchMoreData}
                hasMore={articles.length !== totalResults}
                loader={loading && <Spinner />}
            >
                <div className="container">
                    <div className="row">
                        {articles.map((element, index) => {
                            return <div className="col-md-4" key={index}>
                                {/* <NewsItem title={element.title.length <= 73 ? element.title : (element.title.slice(0, 73) + "...")} description={element.description.length < 100 ? element.description : element.description.slice(0, 100)} imgurl={element.urlToImage} newsurl={element.url} /> */}
                                <NewsItem title={element.title} description={element.description} imgurl={element.urlToImage} newsurl={element.url} date={element.publishedAt} author={element.author} source={element.source.name} />
                            </div>
                        })}
                    </div>
                </div>

            </InfiniteScroll>
            {/* <div className="container d-flex justify-content-between">
                        <button disabled={this.state.page <= 1} onClick={this.handleprevbutton} type="button" className="btn btn-dark">&#8249; Prev</button>
                        <button disabled={this.state.page > Math.ceil(this.state.totalResults) / props.pagesize} onClick={this.handlenextbutton} type="button" className="btn btn-dark">Next &#8250;</button>
                    </div> */}

        </div>
    )
}

News.defaultProps = {
    country: 'us', pagesize: 6, category: 'general',
}
News.propTypes = {
    country: PropTypes.string, pagesize: PropTypes.number, category: PropTypes.string,
}

export default News